const dropdownPicker = document.querySelector('.js-dropdown-picker');
const dropdownItems = document.querySelectorAll('.js-dropdown-item');

if (dropdownPicker && window.screen.width < 479) {
    dropdownPicker.addEventListener('click', () => {
        dropdownPicker.classList.add('open');
        dropdownItems.forEach(elem => {
            elem.classList.add('active');
        })

    })

    document.addEventListener('click', event => {
        const isClickInside = dropdownPicker.contains(event.target);

        if (!isClickInside) {
            dropdownPicker.classList.remove('open');
            dropdownItems.forEach(elem => {
                elem.classList.remove('active');
            })
        }
    })
}